__turbopack_context__.v({
  "coverTypeRichText": "slAFFW_coverTypeRichText",
});
